<nz-form-item>
  <mac-form-input-text class="custom-input" [label]="'Shared.Communication.Subject' | translate"
    [placeholder]="'Shared.Communication.Subject' | translate" [formControl]="subjectFormControl"
    [addOnAfter]="suffixContent">
  </mac-form-input-text>
  <ng-template #suffixContent>
    <button [disabled]="subjectFormControl.disabled" nz-button nz-dropdown [nzDropdownMenu]="menu"
      nzTrigger="click">%</button>
    <nz-dropdown-menu #menu="nzDropdownMenu">
      <ul nz-menu>
        <li *ngFor="let availableParameter of communicationDefinition.availableParameters"
          (click)="addParameter(subjectFormControl, availableParameter.code)" nz-menu-item>
          {{ availableParameter.code }}
        </li>
      </ul>
    </nz-dropdown-menu>
  </ng-template>
</nz-form-item>
<ng-container *ngIf="bodyFormControl.disabled">
  <div class="disabled" [innerHTML]="bodyFormControl.value"></div>
</ng-container>
<ng-container *ngIf="!bodyFormControl.disabled && showEditor">
  <textarea [id]="editorId" (froalaInit)="froalaInit($event)" [froalaEditor]="froalaOptions"></textarea>
</ng-container>